export const SUPPORTED_LOCALES = ['pt', 'en', 'es'];
export const DEFAULT_LOCALE = 'pt';
export const LOCALE_STORAGE_KEY = 'weeduc_locale';
export const LEGACY_LOCALE_STORAGE_KEY = 'lenguage';

export const INTL_LOCALES = {
    pt: 'pt-BR',
    en: 'en-US',
    es: 'es-ES',
};

export const HTML_LANG = {
    pt: 'pt-BR',
    en: 'en',
    es: 'es',
};

let vuetifyInstance = null;

export function isSupportedLocale(locale) {
    return SUPPORTED_LOCALES.includes(locale);
}

export function persistLocale(locale) {
    if (typeof window === 'undefined' || !isSupportedLocale(locale)) return;
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
    localStorage.setItem(LEGACY_LOCALE_STORAGE_KEY, locale);
}

export function getSavedLocale() {
    if (typeof window === 'undefined') {
        return DEFAULT_LOCALE;
    }
    const saved =
        localStorage.getItem(LOCALE_STORAGE_KEY) ||
        localStorage.getItem(LEGACY_LOCALE_STORAGE_KEY);
    if (isSupportedLocale(saved)) {
        return saved;
    }
    persistLocale(DEFAULT_LOCALE);
    return DEFAULT_LOCALE;
}

export function applyDocumentLang(locale) {
    if (typeof document === 'undefined') return;
    document.documentElement.lang = HTML_LANG[locale] || HTML_LANG[DEFAULT_LOCALE];
}

export function intlLocale(locale) {
    const current =
        locale && typeof locale === 'object' && 'value' in locale
            ? locale.value
            : locale || getSavedLocale();
    return INTL_LOCALES[current] || INTL_LOCALES[DEFAULT_LOCALE];
}

export function bindVuetify(instance) {
    vuetifyInstance = instance;
}

export function syncVuetifyLocale(locale) {
    if (!vuetifyInstance?.locale) return;
    const current = vuetifyInstance.locale.current;
    if (current && typeof current === 'object' && 'value' in current) {
        current.value = locale;
        return;
    }
    vuetifyInstance.locale.current = locale;
}
